import React, { useEffect, useState } from "react";

import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";

import ImportantToKnow from "../components/ImportantToKnow";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

const about = () => {
  // ============================================================
  // LANGUAGE
  // ============================================================

  //const { languageId } = useLanguage();
const { language , t} = useLanguage();
const languageId = language?.lang_id || 1;
  // ============================================================
  // STATE
  // ============================================================

  const [content, setContent] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  // ============================================================
  // PAGE ID
  // ============================================================

  const PAGE_ID = 3;

  // ============================================================
  // CLEAN HTML
  // ============================================================

  const cleanContentHtml = (html) => {
    if (!html) {
      return "";
    }

    return String(html)
      .replace(
        /<li>\s*<\/li>/gi,
        ""
      )
      .replace(
        /<li>(?:\s|&nbsp;|<br\s*\/?>)*<\/li>/gi,
        ""
      )
      .replace(
        /<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi,
        ""
      )
      .replace(
        /<div>(?:\s|&nbsp;|<br\s*\/?>)*<\/div>/gi,
        ""
      );
  };

  // ============================================================
  // FETCH ABOUT CONTENT
  // ============================================================

  useEffect(() => {
    let cancelled = false;

    const fetchAbout = async () => {
      try {
        setLoading(true);
        setError("");

        const langId = languageId || 1;

        console.log(
          "===================================="
        );

        console.log(
          "ABOUT PAGE API REQUEST"
        );

        console.log({
          page_id: PAGE_ID,
          lang_id: langId,
        });

        const response = await api.get(
          "/contents/content",
          {
            params: {
              page_id: PAGE_ID,
              lang_id: langId,
            },
          }
        );

        console.log(
          "===================================="
        );

        console.log(
          "ABOUT API RESPONSE:"
        );

        console.log(
          response
        );

        console.log(
          "ABOUT API DATA:"
        );

        console.log(
          response.data
        );

        // ======================================================
        // API RESPONSE
        // ======================================================

        if (
          response.data?.success !== true
        ) {
          console.warn(
            "ABOUT API SUCCESS IS FALSE"
          );

          setContent(null);

          setError(
            response.data?.message ||
              "Unable to load About content."
          );

          return;
        }

        // ======================================================
        // DATA
        // ======================================================

        let aboutData =
          response.data?.data;

        console.log(
          "ABOUT DATA BEFORE NORMALIZATION:",
          aboutData
        );

        // ======================================================
        // SUPPORT ARRAY ALSO
        // ======================================================

        if (
          Array.isArray(aboutData)
        ) {
          aboutData =
            aboutData[0] || null;
        }

        console.log(
          "ABOUT FINAL CONTENT:",
          aboutData
        );

        // ======================================================
        // CANCELLED
        // ======================================================

        if (cancelled) {
          return;
        }

        // ======================================================
        // SET CONTENT
        // ======================================================

        if (aboutData) {
          setContent({
            cont_id:
              aboutData.cont_id,

            page_id:
              aboutData.page_id,

            lang_id:
              aboutData.lang_id,

            cont_title:
              aboutData.cont_title || "",

            cont_details:
              aboutData.cont_details || "",
          });

          console.log(
            "ABOUT CONTENT SET SUCCESSFULLY"
          );

        } else {
          setContent(null);

          setError(
            "About content is empty."
          );
        }

      } catch (err) {
        console.error(
          "===================================="
        );

        console.error(
          "ABOUT API ERROR"
        );

        console.error(
          err
        );

        console.error(
          "ERROR RESPONSE:",
          err?.response
        );

        console.error(
          "ERROR DATA:",
          err?.response?.data
        );

        if (!cancelled) {
          setContent(null);

          setError(
            err?.response?.data?.message ||
              "Unable to load About content."
          );
        }

      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchAbout();

    return () => {
      cancelled = true;
    };

  }, [languageId]);

  // ============================================================
  // LOADING
  // ============================================================

  if (loading) {
    return (
	
      <div className="about-page">

        <section
          className="about ftco-section ftco-about"
          style={{
            padding: "60px 0",
          }}
        >

          <div className="container">

            <div
              style={{
                minHeight: "300px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >

              <div
                className="spinner-border"
                role="status"
              >
                <span className="visually-hidden">
                  Loading...
                </span>
              </div>

              <p
                style={{
                  marginTop: "15px",
                }}
              >
                Loading About...
              </p>

            </div>

          </div>

        </section>

      </div>
	  
    );
  }

  // ============================================================
  // ERROR
  // ============================================================

  if (error) {
    return (
      <div className="about-page">

        <section
          className=" about ftco-section ftco-about"
          style={{
            padding: "60px 0",
          }}
        >

          <div className="container">

            <div className="text-center">

              <h3>
                Something went wrong
              </h3>

              <p>
                {error}
              </p>

              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  window.location.reload()
                }
              >
                Try Again
              </button>

            </div>

          </div>

        </section>

      </div>
    );
  }

  // ============================================================
  // NO CONTENT
  // ============================================================

  if (!content) {
    return (
      <div className="about-page">

        <section
          className="about ftco-section ftco-about"
          style={{
            padding: "60px 0",
          }}
        >

          <div className="container">

            <div className="text-center">

              <h2>
                 {content.cont_title}
              </h2>

              <p>
                No About content available.
              </p>

            </div>

          </div>

        </section>

        <ImportantToKnow />

      </div>
    );
  }

  // ============================================================
  // FINAL PAGE
  // ============================================================

  return (
    <div className="about-page">
	<div className=" bg-box ">
      <section className="modify1 about-us professional-faq-hero">

        <div className="professional-faq-overlay"></div>

        <div className="container">

          <div className="professional-faq-hero-content">

           
            <span className="faq-eyebrow" style={{ textTransform: "uppercase" }}>
              {t("menu.menu10", "CRETE HOLIDAYS")}
            </span>
            <h1>
            {content.cont_title}
            </h1>

            <p>
              {t("othersnewstatics.othersnewstatic20", "Already since 2000, we mediate in the rental of cars in Crete in a clear manner.")}
            </p>

          </div>

        </div>

      </section>
</div>
<div className="clearfix"></div>
      {/* ======================================================
          ABOUT SECTION
      ====================================================== */}

      <div className="p20">

        <section
          className="
            about
            ftco-section
            ftco-about
          "
          style={{
            padding: "0",
          }}
        >

          <div className="container">

            <div className="row no-gutters">

              {/* =================================================
                  TITLE
              ================================================= */}

              <div
                className="col-md-12"
                style={{
                  textAlign: "center",
                }}
              >

                <div
                  className="
                    heading-section
                    heading-section-white
                  "
                >

                  <h2
                    className="aboutp"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {content.cont_title}
                  </h2>

                </div>

              </div>


              {/* =================================================
                  CONTENT
              ================================================= */}

              <div
                className="col-md-12"
                style={{
                  textAlign: "center",
                }}
              >

                <div
                  className="
                    col-md-12
                    wrap-about
                    ftco-animate
                  "
                  style={{
                    padding: "0 15px",
                  }}
                >

                  <div
                    className="
                      heading-section
                      heading-section-white
                    "
                    style={{
                      textAlign: "left",
                    }}
                  >

                    <div
                      className="about-main-content"
                      dangerouslySetInnerHTML={{
                        __html:
                          cleanContentHtml(
                            content.cont_details
                          ),
                      }}
                    />

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>

      </div>


      {/* ======================================================
          IMPORTANT TO KNOW

          OLD HTML REMOVED
      ====================================================== */}

      <ImportantToKnow />

    </div>
  );
};

export default about;